import { ButtonProps } from '@cp/ds/src/components/button/model';

export enum FavoriteVariant {
  text = 0,
  icon = 1,
}

export interface FavoriteProps extends Omit<ButtonProps, 'variant'> {
  authorId: number;
  variant?: FavoriteVariant;
}
